module.exports = __webpack_public_path__ + "static/img/doublelift.d1ede07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-banner/doublelift-course/doublelift.png
// module id = 4qHP
// module chunks = 35